<template>
  <div>
    <div class="form-group">
      <label class="custom-label" style="width: 100%">{{labelDesc}}</label>
      <div class="form d-inline w-100">
        <button v-if="iconSelected" class="btn btn-outline-light p-2 border-0"><i :class="$addIconPrefix(iconSelected)"></i></button>
        <button class="btn btn-outline-info ml-1" @click="showIcon" style="max-width: 175px;">{{ $t('ct-show-list-icon') }}</button>
        <font-awesome-icon
          :icon="['far', 'trash-alt']"
          v-tooltip="{content:$t('ct-option-delete'),  class: 'tooltip-custom'}"
          class="font-awesome-icon danger ml-2"
          v-on:click="removeIcon"
          v-show="iconSelected !== '' && canRemove"
        />
      </div>
    </div>

    <div class="icon-settings-content-align"  v-show="iconSelected !== '' && this.showAlign !== false">
      <div class="form-group" :key="key">
        <label>{{ $t('ct-align') }}</label>
        <div
          class="btn-icon-group"
        >
          <button
            type="button"
            class="btn-icon-align"
            value="left"
            :class="{'active' : position ===  'left'}"
            @click="changePos('left')"
          >
            <span>{{ $t('ct-left') }}</span>
            <i class="input-radio-icon"/>
          </button>
          <!--        <button type="button" class="btn btn-secondary" value="top" @click="changePos('top')">Top-->
          <!--        </button>-->
          <button
            type="button"
            class="btn-icon-align"
            value="right"
            :class="{'active' : position ===  'right'}"
            @click="changePos('right')"
          >
            <span>{{ $t('ct-right') }}</span>
            <i class="input-radio-icon"/>
          </button>
          <!--        <button type="button" class="btn btn-secondary" value="bottom" @click="changePos('bottom')">Bottom-->
          <!--        </button>-->
        </div>
      </div>
    </div>

    <sweet-modal :title="$t('ct-add-icon-title')" ref="modal" width="70vw" @open="unsetRightPanelOverflow(true)" @close="unsetRightPanelOverflow(false)">
      <div class="text-icons-input-container input-group mb-3">
        <select v-model="selectedLibraryName" class="mr-1 ba-select">
          <option value="material">Material icons</option>
          <!-- 
          <option value="faSolid">Font Awesome Solid</option>
          <option value="faRegular">Font Awesome Regular</option>
          -->
          <option value="faBrands">Font Awesome Brands</option>
        </select>
        <div class="input-group-prepend">
          <span class="input-group-text"><font-awesome-icon icon="search"/></span>
        </div>
        <input type="text" class="form-control" :placeholder="$t('ct-search')" v-model="filter">
      </div>
      <div class="text-icons-container" ref="text-icons-container" v-if="!loading && iconsList.length">
        <div v-for="(element,index) in iconsList" :key="index" class="item-icon show" :data-name="element">
          <i
            :class="[element, {focused: element == iconSelected}]"
            @click="selectIcon(element)"
            :value="element">
          </i>
        </div>
      </div>
      <div class="text-icons-container" v-else-if="!loading && !iconsList.length">
        <p class="mb-0 text-center">{{ $t('ct-icon-not-found')}}</p>
      </div>
      <div class="text-icons-container" v-else>
        <div class="text-center">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
      <button slot="button" class="btn btn-outline-light" @click="close">{{ $t('ct-cancel') }}</button>
      <button slot="button" class="btn btn-success" @click="save"><i class="svg-icon svgi-save"></i>{{ $t('ct-select') }}</button>
    </sweet-modal>
  </div>
</template>
<script>
import IconList from './Abstract/IconList';
import { SweetModal } from 'sweet-modal-vue';

export default {
  name: 'IconComponent',
  components: {
    IconList,
    SweetModal
  },
  data() {
    return {
      iconsListGroups: IconList.data(),
      iconsList: [],
      element: null,
      value: '',
      labelDesc: 'opa',
      callback: null,
      showAlign: true,
      canRemove: true,
      filter: '',
      iconSelected: '',
      libraryPrefix: '',
      position: '',
      loading: false,
      key: 1, // force change
      selectedLibraryName: undefined,
    };
  },

  watch: {
    selectedLibraryName() {
      this.iconsList = JSON.parse(JSON.stringify(this.iconsListGroups[this.selectedLibraryName]))
      if (this.filter) this.filterSelection()
    },
    filter() {
      this.filterSelection()
    }
  },

  methods: {
    changePos(value) {
      this.position = value;
      this.callback();
    },

    removeIcon() {
      this.iconSelected = '';
      this.callback();
    },

    save() {
      this.callback();
      this.$refs.modal.close();
    },

    close() {
      this.iconSelected = '';
      this.$refs.modal.close();
    },

    selectIcon(icon) {
      if (icon === this.iconSelected) { return }
      this.iconSelected = icon;
    },

    filterSelection() {
      let c = this.filter.toLowerCase().trim();
      this.iconsList = JSON.parse(JSON.stringify(
        this.iconsListGroups[this.selectedLibraryName].filter(
          icon => icon.indexOf(c) > -1
        )
      ))
    },
    
    showIcon() {
      let vm = this;
      this.loading = true;

      this.filter = '';
      this.selectedLibraryName = 'material'
      this.$refs.modal.open();

      setTimeout(function() {
        vm.loading = false;
      }, 500);
    },
    changeValue() {
      this.callback();
    },
    setValues(obj) {
      // this.element = obj.element;
      this.iconSelected = obj.defaultIcon;
      this.position = obj.defaultPosition;

      this.showAlign = obj.showAlign;
      this.canRemove = typeof (obj.canRemove) === 'undefined' ? true : obj.canRemove;

      this.labelDesc = this.$t(`ct-${obj.labelDesc}`);
      this.callback = obj.callback;

      this.key += 1
    },
    unsetRightPanelOverflow(unset) {
      /** @type HTMLDivElement */
      const panelComponentsRight = document.querySelector(".panel-components-right");
      if (!panelComponentsRight) return;
      panelComponentsRight.classList.toggle('panel-components-right--overflow-unset', unset);
    },
  }
};
</script>
<style scoped lang="scss">
.ba-select {
  color: #8d9eb5;
  background-color: #f4f6fb;
  border: none;
  border-radius: 6px;
  outline: none;
  min-height: 35px;
  padding: 6.4px 12.8px;
  font-size: 12.8px;
  font-weight: 600;
}
.form-group {
  overflow: hidden;
}
</style>
<style lang="scss">

.item-icon {
  display: none;
  width: 40px;
  height: 40px;
  font-size: 30px;
  cursor: pointer;

  .focused {
    border-radius: 5px;
    color: #FFF;
    background-color:#0080FC;
  }

  i {
    width: 40px;
    height: 40px;
    text-align: center;
  }
}

.item-icon {
  display: none;
  width: 40px;
  height: 40px;
  font-size: 30px;
  cursor: pointer;

  .focused {
    border-radius: 5px;
    color: #FFF;
    background-color: #0080FC;
  }

  i {
    width: 40px;
    height: 40px;
    align-items: center;
    justify-content: center;
    display: flex;
  }
}

.text-icons-input-container {
  background: #FFFFFF;
  border: 1px solid #DDDDDD;
  border-radius: 3px;
  height: 46px;

  .input-group-append {
    .btn {
      height: 100%;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      box-shadow: none;

      font-size: 13px;
      font-weight: bold;
      font-family: "Muli", "Lato", "Helvetica Neue", Helvetica, Arial, sans-serif;
    }
  }

  .input-group-text {
    margin-left: 5px;

    background: none;
    border: none;
    color: #A8A8A8;
  }

  input {
    height: 40px;
    border: none;
    margin-top: 3px;

    font: normal normal normal 14px Lato;
    color: #656565;
  }
}

.text-icons-container {
  padding: 20px;
  max-height: 50vh;
  overflow: auto;
  background: #FFFFFF;
  border: 1px solid #DDDDDD;
  border-radius: 3px;

  .item-icon {
    margin-left: 3px;
    margin-right: 3px;

    &.show {
      display: inline-flex;
    }
  }
}
</style>
<style>
.panel-components-right--overflow-unset {
  overflow: unset !important;
}
</style>



// WEBPACK FOOTER //
// src/components/editor/resources/Icon.vue